import { isOnline } from '../../shell/connectivity/connectivityInfra';
import { useAuthStore } from '../../auth/store/useAuthStore';
import type { BarcodeLookupRemoteResult } from '../domain/barcodeLookup';
import { resolveBarcodeLookupHttpError } from '../domain/barcodeLookupHttpError';

export { resolveBarcodeLookupHttpError } from '../domain/barcodeLookupHttpError';

const getFunctionsBaseUrl = () => {
  const explicit = process.env.EXPO_PUBLIC_SUPABASE_FUNCTIONS_URL;
  if (explicit) return explicit.replace(/\/$/, '');
  const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL ?? '';
  return `${supabaseUrl.replace(/\/$/, '')}/functions/v1`;
};

export const hasNetworkConnection = () => isOnline();

export const lookupBarcodeRemotely = async (barcode: string): Promise<BarcodeLookupRemoteResult> => {
  const { session } = useAuthStore.getState();
  if (!session?.access_token) {
    throw new Error('Debés iniciar sesión.');
  }

  const url = `${getFunctionsBaseUrl()}/barcode-lookup`;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${session.access_token}`,
  };

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ barcode }),
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(resolveBarcodeLookupHttpError(body, 'No pudimos consultar el catálogo online.'));
  }

  if (typeof body?.found !== 'boolean' || typeof body?.barcode !== 'string') {
    throw new Error('Respuesta inválida del servicio de barcode.');
  }

  return body as BarcodeLookupRemoteResult;
};
